import { EnemyBase } from 'app/Actor/Enemy/EnemyBase';
import { IActor } from './../IActor';

export class TriangleInvader extends EnemyBase {

    constructor(){
        super();
    }

}


// WEBPACK FOOTER //
// D:/xamppabeel/htdocs/Angular2Projects/CanvasSVG/src/app/Actor/Enemy/TriangleInvader.ts